module.exports = __webpack_public_path__ + "img/person-booth.62a04f73.svg";